import { createContext, useContext } from 'react';
import type { PqUser } from '@/lib/pq-client';

export interface AccountContextValue {
    userId: string;
    account: PqUser;
    refreshAccount: () => Promise<PqUser>;
    signOut: () => Promise<void>;
}

export const AccountContext = createContext<AccountContextValue | null>(null);

export function useAccount(): AccountContextValue {
    const context = useContext(AccountContext);
    if (!context) throw new Error('useAccount must be used inside AccountGate');
    return context;
}
